module.exports = __webpack_public_path__ + "img/shortcut-booking-instant.cc2bd1fb.svg";